import classnames from 'classnames'

import Text, { TextSizes } from '~/components/atoms/Text/Text'

import styles from './Lozenge.module.css'

export interface LozengeProps {
  onClick?: () => void
  title: string
  isActive?: boolean
  smallOnMobile?: boolean
  reducedSize?: boolean
  themeAccent?: string
}

function Lozenge({
  title,
  onClick,
  smallOnMobile = false,
  isActive = false,
  reducedSize = false,
  themeAccent,
}: LozengeProps) {
  const styleProps: { [key: string]: string } = {}
  if (themeAccent) {
    styleProps['--themeAccent'] = themeAccent
  }

  return (
    <>
      <div
        className={classnames(
          styles.button,
          smallOnMobile && styles.smallOnMobile,
          isActive && styles.isActive,
          reducedSize && styles.reducedSize
        )}
        style={styleProps}
        onClick={onClick && onClick}
      >
        <Text size={TextSizes.primaryTitleSml} uppercase={true}>
          {title}
        </Text>
      </div>
    </>
  )
}

export default Lozenge
